import axios from "axios";

// axiosInstance.defaults.withCredentials = true
// axios.defaults.withCredentials = true;
export class authServies {
  static serverUrl = `https://www.cryptoprofits.finance`;

  static http = axios.create({
    baseURL: this.serverUrl,
    headers: {
      "X-Requested-with": "XMLHttpRequest",
      Accept: "application/json",
    },
    withCredentials: true,
  });
}
